import {BUS_SESSION_CUSTOM_FIELDS_CHANGE} from "../../gd/bus/bus-event-type";
import SessionEventProto from "../session-event-proto";


export default class EventCustomFieldsResetByCompany extends SessionEventProto {


    constructor(sessionEvent: any) {
        super(sessionEvent)

        // this.restartApps = ['organization-settings-custom-fields']
    }

    process() {

        gd.session.customFields.resetAndMarkOldModelsAsDeleted(this.data.customFields, this.data.companyId)

        gd.bus.triggerEvent(BUS_SESSION_CUSTOM_FIELDS_CHANGE)



        // if (this.restartApps && this.restartApps.length>0) {
        //     this.restartApps.map(function(appName){
        //         if (gd.app && gd.app.name===appName) {
        //             if (debug.dev) console.log(debug.head,"restarting...",appName);
        //             gd.app.start();
        //         }
        //     })
        // }


    }
}

